import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from "react-redux";
import close from "../../assets/images/close.svg";
import FpgPlusIcon from "../../icons/fpgplusicon";
import FpgMinusIcon from "../../icons/fpgminusicon";
import DropdownMaster from './../../component/DropdownMaster';
import TextField from './../../component/TextField';
import service from "../../services";
import SimpleReactValidator from 'simple-react-validator';
import Loader from '../../component/loader';
import { PAF_TYPES, isNewFrontierCategory } from '../../cosntants';


let sub
const CreateProjectPopup = (props) => {
    let apiserve = new service();
    const loader = apiserve.loader
    const COUNTRIES = useSelector((state) => state.countries)
    const [loglineValidation, setLoglineValidation] = useState(false)
    const [loglineLength, setLoglineLength] = useState(0)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const firstFormValidator = useRef(new SimpleReactValidator(
        {
            autoForceUpdate: this,
            validators: {
                title: {  // name the rule
                    message: 'Title is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                pafType: {  // name the rule
                    message: 'PAF Type is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                category: {  // name the rule
                    message: 'Category is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                filmProjectType: {  // name the rule
                    message: 'Film / Project Type is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                country: {  // name the rule
                    message: 'Country of Origin is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                logline: {  // name the rule
                    message: 'Logline is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        }
    ))
    const secondFormValidator = useRef(new SimpleReactValidator(
        {
            autoForceUpdate: this,
            validators: {
                CFirstLast: {  // name the rule
                    message: 'First and Last Name are required',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                creditId: {  // name the rule
                    message: 'Credits is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                formEmail: {  // name the rule
                    message: 'Email is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                email: {  // name the rule
                    message: 'Please Enter Valid Email.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[a-zA-Z0-9](?!.*[.\-+_]{2})[a-zA-Z0-9._+-]*[a-zA-Z0-9]@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                firstName: {  // name the rule
                    message: 'First Name is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                lastName: {  // name the rule
                    message: 'Last Name is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                phone: {  // name the rule
                    message: 'Phone is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                projectUserId: {  // name the rule
                    message: 'Project User ID is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                pId_alpha_num: {  // name the rule
                    message: 'Project User ID must only contain alphanumeric characters.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[0-9a-zA-Z]*$/) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        }
    ))
    const [credits, setCredit] = useState([{
        _id: Math.random(),
        creditId: '',
        creditLabel: '',
        identifier: '',
        creditType: [{
            _id: Math.random(),
            firstName: '',
            middleName: '',
            lastName: ''
        }]
    }])

    const [checkTyping, setCheckTyping] = useState({
        typing: false,
        typingTimeout: 0,
        searchText: '',
        projectLoader: false,
        emailLoader: false
    })
    const [isLoading, setIsLoading] = useState(false)
    const [Loading, setLoading] = useState(false)
    const [creditShow, setCreditShow] = useState(false)
    const [creditCounter, setCreditCounter] = useState(0)
    const [btnDisabel, setbtnDisabel] = useState(true);
    const [state, setState] = useState({
        formData: {},
        pafType: '',
        category: '',
        filmProjectType: '',
    })
    const [checkProjectID, setCheckProjectID] = useState({
        errorMessage: '',
        error: false
    })
    const [checkEmail, setCheckEmail] = useState({
        errorMessage: '',
        error: false
    })
    const [formDetail, setFormDetail] = useState({
        pafType: '',
        filmProjectType: '',
        category: '',
        countryOfOrigin: [],
        article: '',
        title: '',
        logline: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        phone: '',
        projectUserId: '',
        countryOfOrigin: [{
            id: new Date().getTime().toString(),
            country: ''
        }]

    })
    const [projectCredits,setProjectCredits] = useState(state ?.pafType === PAF_TYPES.NEW_FRONTIER ? {
        leadartist: 3,
        keycollaborator: 2,
        principalcast: 5
    } :
        {
            director: 3,
            screenwriter: 2,
            // producer: 5,
            principalcast: 5
            // cast:6
        })
    const [alertPopup, setAlertPopup] = useState(false);
    const [errorPopup, setErrorPopup] = useState({flag:false, message:''});
    useEffect(() => {
        getDropValues();
        sub = apiserve.getevent().subscribe((response) => {
            if (!response.error) {

                switch (response.event) {
                    case "paf|project|getDetail":

                        setState({ formData: response.data })

                        setIsLoading(false)
                        forceUpdate()
                        break;
                    case "paf|project|add":
                        if(!response.error){
                            apiserve.success('Project Create Successfully!!')
                            apiserve.sendevent("paf|project|projectList", { limit: 50, page: 0, });
                            setLoading(false)
                            props.closeProject()
                            forceUpdate()
                        }
                        break;
                    default:
                        break;
                }
            } else {
                console.log(response);
            }
            switch (response.event) {
                case 'paf|project|checkProjectId':
                    if(response.data.error){
                        setCheckProjectID({
                            errorMessage: response.data.error,
                            error: response.error
                        })
    
                        setCheckTyping({
                            projectLoader: false,
                        })
                    } else{
                        setCheckProjectID({
                            errorMessage: response.data.error,
                            error: response.error
                        })
                        setCheckTyping({
                            projectLoader: false,
                        })
                    }
                    break;
                case 'paf|project|checkEmail':
                    setCheckEmail({
                        errorMessage: response.data.error,
                        error: response.error
                    })
                    setCheckTyping({
                        emailLoader: false,
                    })
                    break;
                case "paf|project|add":
                    setLoading(false)
                    setErrorPopup({flag:true, message:response.data.error})
                    forceUpdate()
                    break;
                default:
                    break;
            }
        })
        return () => {
            sub.unsubscribe()
        }
    }, [])

    const getDropValues = () => {
        apiserve.sendevent("paf|project|getDetail", {});
        setIsLoading(true)
    }

    const getCreditCount = () => {
        let num = 0
        credits.forEach((item, i) => {
            if (item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast') {
                num = num + item.creditType.length
            }
        })
        setCreditCounter(num)
        return num
    }

    const addCredit = (item) => {
        var newCredit = {
            _id: Math.random(),
            creditId: '',
            creditLabel: '',
            identifier: '',
            creditType: [{
                _id: Math.random(),
                firstName: '',
                middleName: '',
                lastName: ''
            }]
        }
        var oldCredit = credits
        oldCredit.push(newCredit)
        setCredit(oldCredit);
        getCreditCount()
        setCreditShow(true)
        forceUpdate()
    }

    const removeCredit = (id) => {
        var filteredCredit = credits.filter(_ => _._id !== id)
        setCredit(filteredCredit);
        let num = 0;
        filteredCredit.forEach((item, i) => {
            if (item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast') {
                num = num + item.creditType.length
            }
        })
        setCreditCounter(num)
        forceUpdate()
    }

    const NextStep = () => {
        if (firstFormValidator.current.allValid() && !loglineValidation) {
            if (formDetail.pafType.length !== 0 && formDetail.category.length !== 0 && (isNewFrontier ? formDetail.filmProjectType.length !== 0 : true) && formDetail.title.length !== 0) {
                setCreditShow(true)
            }
        } else {
            firstFormValidator.current.showMessages()
            forceUpdate()
        }
    }

    const BackStep = () => {
        setCreditShow(false)
    }

    const onInputChange = (e) => {

        if (!e.target.validity.valid) {
            return null;
        }
        const { name, value } = e.target
        if (name === 'logline') {
            let len = value.split(/\s+/)
            len = len.filter(_ => _ !== '');
            if (len.length <= ((formDetail.pafType === PAF_TYPES.NARRATIVE_SHORTS || formDetail.pafType === PAF_TYPES.DOCUMENTARY_SHORTS) ? 40 : 50)) {
                setFormDetail({
                    ...formDetail,
                    [name]: value
                })
                setLoglineValidation(false)

            } else setLoglineValidation(true)
        } else
            setFormDetail({
                ...formDetail,
                [name]: value
            })
            setProjectCredits(formDetail?.pafType === PAF_TYPES.NEW_FRONTIER ? {
                leadartist: 3,
                keycollaborator: 2,
                principalcast: 5
            } :
                {
                    director: 3,
                    screenwriter: 2,
                    // producer: 5,
                    principalcast: 5
                    // cast:6
                })

    }
    useEffect(() => {
        if (formDetail.firstName && formDetail.lastName && formDetail.email && formDetail.projectUserId) {
            if (checkEmail.error || checkProjectID.error) setbtnDisabel(true)
            else setbtnDisabel(false)
        }
    }, [formDetail, checkProjectID, checkEmail])
    const onEmail_ProjectUserChange = (e, TYPE) => {
        if (checkTyping.typingTimeout) {
            clearTimeout(checkTyping.typingTimeout);
        }

        const { name, value } = e.target
        const Value = value.trim()
        let regex = new RegExp(/^\S*$/);
        setFormDetail({ ...formDetail, [name]: Value })
        if(TYPE !== 'EMAIL'){
            secondFormValidator.current.showMessageFor('projectUserId')
        }
        forceUpdate()
        if(TYPE !== 'EMAIL' && !regex.test(Value)){
            setCheckProjectID({errorMessage:'Space not allowed in Project User Id',error:true})
        } else {
            setCheckTyping({
                typing: false,
                typingTimeout: setTimeout(function () {
                    if (TYPE === 'EMAIL') {
                        setCheckTyping({ ...checkTyping, emailLoader: true })
                        apiserve.sendevent('paf|project|checkEmail', { email: Value })
                    } else {
                        setCheckTyping({ ...checkTyping, projectLoader: true })
                        apiserve.sendevent('paf|project|checkProjectId', { projectUserId: Value })
                    }
                }, 1000)
            });
        }
    }
    useEffect(() => {

        let len = formDetail.logline.split(/\s+/)
        len = len.filter(_ => _ !== '');

        setLoglineLength(len.length)

    }, [formDetail.logline])

    const  moveobjectAtIndex = (array, sourceIndex, destIndex) => {
        var placeholder = {};
        // remove the object from its initial position and
        // plant the placeholder object in its place to
        // keep the array length constant
        var objectToMove = array.splice(sourceIndex, 1, placeholder)[0];
        // place the object in the desired position
        array.splice(destIndex, 0, objectToMove);
        // take out the temporary object
        array.splice(array.indexOf(placeholder), 1);
        return array
    }
    const onSubmit = (e) => {
   
            e.preventDefault();
            if (secondFormValidator.current.allValid() && firstFormValidator.current.allValid() && !checkProjectID.error && !loglineValidation) {
                
                let data = {}
                let castIndex =credits.findIndex(element => element.identifier === 'principalcast')
                let creditLastIndex = credits.length 
            
                    data = {
                        pafType: formDetail.pafType,
                        ...(isNewFrontier ? { filmProjectType: formDetail.filmProjectType } : {}),
                        article: formDetail.article,
                        title: formDetail.title,
                        logline: formDetail.logline,
                        firstName: formDetail.firstName,
                        middleName: formDetail.middleName,
                        lastName: formDetail.lastName,
                        email: formDetail.email,
                        projectUserId: formDetail.projectUserId,
                    }
                    if(formDetail.pafType === PAF_TYPES.DOCUMENTARY_SHORTS || formDetail.pafType === PAF_TYPES.DOCUMENTARY_FEATURES ){
                        data.credits = credits
                    }else{
                        data.credits = moveobjectAtIndex(credits, castIndex ,creditLastIndex)
                    }
                    if(formDetail.category!== '' && formDetail.category!== null && formDetail.category!== undefined){
                        data.category = formDetail.category
                    }
                apiserve.sendevent('paf|project|add', data)
                setLoading(true)
    
            } else {
                secondFormValidator.current.showMessages()
    
                forceUpdate()
            }
        }
    
    const onChangeCredit = (e, CID, IID) => {
        let newCredit = credits
        newCredit.forEach(credit => {
            if (credit._id === CID) {
                credit.creditType.forEach(data => {
                    if (data._id === IID) {
                        const { name, value } = e.target
                        data[name] = value
                    }
                })
            }
        });
        setCredit(newCredit)
        forceUpdate()
        setCreditShow(true)
    }
    const dropChangeCreditLabel = (e, id) => {
        let newCredit = credits
        if (!newCredit.some(el => el.creditId === e.target.value)) {
            newCredit.forEach(credit => {
                if (credit._id === id) {
                    credit.creditId = e.target.value;
                    const creditIndex = formDetail ?.pafType === PAF_TYPES.NEW_FRONTIER ?
                        state.formData.newFrontierCreditLabel.findIndex(_ => _._id === credit.creditId) : state.formData.filmcreditLabels.findIndex(_ => _._id === credit.creditId)
                    credit.creditLabel = formDetail ?.pafType === PAF_TYPES.NEW_FRONTIER ? state ?.formData ?.newFrontierCreditLabel[creditIndex] ?.name : state ?.formData ?.filmcreditLabels[creditIndex] ?.name
                    credit.identifier = formDetail ?.pafType === PAF_TYPES.NEW_FRONTIER ? state ?.formData ?.newFrontierCreditLabel[creditIndex] ?.identifier : state ?.formData ?.filmcreditLabels[creditIndex] ?.identifier
                    credit.creditType = credit.identifier === "screenwriter" ? credit.creditType.length > 3 ? credit.creditType.slice(0, 3) : credit.creditType : credit.identifier === "director" && credit.creditType.length > 4 ? credit.creditType.slice(0, 4) : credit.identifier === "principalcast" && credit.creditType.length > 6 ? credit.creditType.slice(0, 6) : credit.creditType
                }
            });
        }

        setCredit(newCredit)
        setCreditShow(true)
        getCreditCount()
        forceUpdate()
    }
    const addInsideCredit = (item) => {
        if (item.creditId !== '') {
            var creditType = {
                _id: Math.random(),
                firstName: '',
                middleName: '',
                lastName: ''
            }
            credits.forEach(element => {
                if (element._id === item._id) {
                    if (projectCredits[item.identifier] !== undefined) {
                        if (element.creditType.length < (projectCredits[item.identifier] + 1))
                            element.creditType.push(creditType)
                    } else {
                        element.creditType.push(creditType)
                    }
                }
            });
        }
        getCreditCount()
        setCreditShow(true)
        forceUpdate()
    }
    const removeInsideCredit = (parentId, childId) => {
        credits.forEach(element => {
            if (element._id === parentId) {
                var filterInsideCredit = element.creditType.filter(_ => _._id !== childId);
                element.creditType = filterInsideCredit
            }
        });
        getCreditCount()
        setCreditShow(true)
        forceUpdate()
    }
    const formDataChange = (e) => {
        const { name, value } = e.target
        const updatedForm = { ...formDetail, [name]: value };
        if (name === 'category') {
            if (!isNewFrontierCategory(value, state.formData?.filmCategoryData)) {
                updatedForm.filmProjectType = '';
            }
        }
        setFormDetail(updatedForm);
    }
    
    const isNewFrontier = isNewFrontierCategory(formDetail.category, state.formData?.filmCategoryData);

    firstFormValidator.current.purgeFields();
    secondFormValidator.current.purgeFields();

    return (
        <>
        <div className="popup_overlay" onClick={() => !alertPopup ? setAlertPopup(true) : setAlertPopup(false)} >
        <div className="popup_wrapper" onClick={(e) => e.stopPropagation()}>
            <h2> Create New Project <img src={close} onClick={() => !alertPopup ? setAlertPopup(true) : props.closeProject()} />
            </h2>
            <form>
                {
                    !creditShow ?
                        <div className="details">
                            <div className="form_group">
                                <label>PAF Type*</label>
                                <div className="form_group_control">
                                    <div className="form_group_input form_group_select">
                                        <select value={formDetail.pafType ? formDetail.pafType : ""} onChange={(e) => formDataChange(e)} name='pafType'>
                                            <option selected value=''>Select here</option>
                                            {state?.formData?.pafType?.map(((option, i) => <> 
                                            <option key={i} value={option}>{option}</option>
                                            </>
                                            ))}
                                        </select>
                                        {isLoading && <><img className='mini_loader' src={loader} /></>}
                                    </div>
                                    <span style={{ color: 'red' }}> {firstFormValidator.current.message('pafType', formDetail.pafType, 'pafType|required')} </span>
                                </div>
                            </div>

                            <div className="form_group">
                                <label>Category</label>
                                <div className="form_group_control">
                                    <div className="form_group_input form_group_select">
                                        <select value={formDetail.category ? formDetail.category : ''} onChange={(e) => formDataChange(e)} name='category'>
                                            <option selected value=''>Select here</option>
                                            {
                                                state.formData ?.filmCategoryData ?.map(((option, i) => <option key={i} value={option._id}>{option.name}</option>))
                                            }
                                        </select>
                                        {isLoading && <><img className='mini_loader' src={loader} /></>}
                                    </div>
                                    <span style={{ color: 'red' }}>{firstFormValidator.current.message('category', formDetail.category, 'category|required')}</span>
                                </div>
                            </div>

                            {isNewFrontier && (
                            <div className="form_group">
                                <label>Film / Project Type*</label>
                                <div className="form_group_control">
                                    <div className="form_group_input form_group_select">
                                        <select value={formDetail.filmProjectType ? formDetail.filmProjectType : ''} onChange={(e) => formDataChange(e)} name='filmProjectType'>
                                            pafProjectType
                                                <option selected value=''>Select here</option>
                                            {state ?.formData ?.pafProjectType ?.map(((option, i) => <option key={i} value={option}>{option}</option>))}
                                        </select>
                                        {isLoading && <><img className='mini_loader' src={loader} /></>}
                                    </div>
                                    <span style={{ color: 'red' }}>{firstFormValidator.current.message('filmProjectType', formDetail.filmProjectType, 'filmProjectType|required')}</span>
                                </div>
                            </div>
                            )}

                            <div className="form_group">
                                <label>Article</label>
                                <div className="form_group_input">
                                    <input type="text" name="article" id="article"
                                        value={formDetail.article}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                </div>
                            </div>

                            <div className="form_group">
                                <label>Title*</label>
                                <div className="form_group_input">
                                    <input type="text" name="title" id="title"
                                        value={formDetail.title}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                    <span style={{ color: 'red' }}>{firstFormValidator.current.message('title', formDetail.title, 'title|required')}</span>
                                </div>
                            </div>
                            <div className="form_group" style={{ alignItems: "flex-start" }}>
                                <label className="mt_10">Logline</label>
                                <div className="form_group_input">
                                    <textarea name="logline" id="logline" rows="8" value={formDetail.logline} onChange={(e) => onInputChange(e)} ></textarea>
                                    <span style={{ color: 'red' }}>{loglineValidation && `More than ${formDetail.pafType === PAF_TYPES.NARRATIVE_SHORTS || formDetail.pafType === PAF_TYPES.DOCUMENTARY_SHORTS ? '40' : '50'} Words is not allowed.`}</span>
                                    <div className="textarea_word sd_flex sd_aligncenter text_right">
                                        <span>Word Count </span>
                                        <span>{loglineLength}/{formDetail.pafType === PAF_TYPES.NARRATIVE_SHORTS || formDetail.pafType === PAF_TYPES.DOCUMENTARY_SHORTS ? '40' : '50'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={`detail_second ${creditShow ? 'active_credit' : ''}`}>
                            <div className="form_group">
                                <p className="form_group_title">Credits*</p>
                            </div>
                            <div>
                                <ul>
                                    {credits.length > 0 && credits.map((item, index) => {
                                        return (
                                            <li className="d_flex d_flex_align_center d_flex_align_start" >
                                                <div>
                                                    <div className="dopdown_add_remove d_flex d_flex_align_center">
                                                        <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                                            {index === 0 ?
                                                                (formDetail ?.pafType === PAF_TYPES.NEW_FRONTIER || formDetail?.pafType === PAF_TYPES.INDIE_SERIES) && <span className="ml_5 mr_5" style={{ cursor: (creditCounter >= 24 || credits.length >= 10) ? 'not-allowed' : 'pointer' }} onClick={() => (creditCounter >= 24 || credits.length >= 10) ? '' : addCredit(item)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                </span>
                                                                :
                                                                <>
                                                                <span className="pointer" onClick={() => removeCredit(item._id)}>
                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                </span>
                                                                <span className="ml_5 mr_5" style={{ cursor: (creditCounter >= 24 || credits.length >= 10) ? 'not-allowed' : 'pointer' }} onClick={() => (creditCounter >= 24 || credits.length >= 10) ? '' : addCredit(item)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                </span>
                                                                </>
                                                            }
                                                        </p>
                                                        <div className="field_row mb_0">
                                                            <DropdownMaster
                                                                name="creditId"
                                                                options={
                                                                    formDetail ?.pafType === PAF_TYPES.NEW_FRONTIER ? state ?.formData ?.newFrontierCreditLabel : formDetail?.pafType === PAF_TYPES.INDIE_SERIES ? state ?.formData ?.filmcreditLabels.filter(_ => _.identifier === 'creator' || _.identifier === 'coexecutiveproducer' || _.identifier === 'director' || _.identifier === 'executiveproducer' || _.identifier === 'showrunner') : state ?.formData ?.filmcreditLabels.filter(_ => _.identifier === 'director')
                                                                    }
                                                                value={item.creditId ? item.creditId : ''}
                                                                onChange={(e) => dropChangeCreditLabel(e, item._id)}
                                                            />

                                                        </div>
                                                    </div>
                                                    <span style={{ color: 'red', textAlign: 'center' }}>{secondFormValidator.current.message(`creditId${index}`, item.creditId, 'creditId|required')}</span>
                                                </div>
                                                <div>
                                                    {item && item.creditType.map((insideCredit, indsideIndex) => (
                                                        <>
                                                        <div className="textfield_add_remove d_flex d_flex_align_center">
                                                            <div className="field_row mb_0 ml_10">
                                                                <TextField
                                                                    type="text"
                                                                    name="firstName" id="first"
                                                                    placeholder="First"
                                                                    value={insideCredit.firstName}
                                                                    onChange={(e) => onChangeCredit(e, item._id, insideCredit._id)}
                                                                />
                                                            </div>
                                                            <div className="field_row mb_0 mr_10 ml_10">
                                                                <TextField
                                                                    type="text"
                                                                    name="middleName" id="middle"
                                                                    placeholder="Middle"
                                                                    value={insideCredit.middleName}
                                                                    onChange={(e) => onChangeCredit(e, item._id, insideCredit._id)}
                                                                />
                                                            </div>
                                                            <div className="field_row mb_0">
                                                                <TextField
                                                                    type="text"
                                                                    name="lastName" id="last"
                                                                    placeholder="Last"
                                                                    value={insideCredit.lastName}
                                                                    onChange={(e) => onChangeCredit(e, item._id, insideCredit._id)}
                                                                />

                                                            </div>
                                                            <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                                                                {indsideIndex === 0 ?
                                                                    <span className="ml_5 mr_5" style={{ cursor: (creditCounter >= 24 || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? 'not-allowed' : 'pointer' }} onClick={() => (creditCounter >= 24 || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? '' : addInsideCredit(item)}>
                                                                        <FpgPlusIcon className="" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                    :
                                                                    <>
                                                                    <span className="ml_5 mr_5" style={{ cursor: (creditCounter >= 24 || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? 'not-allowed' : 'pointer' }} onClick={() => (creditCounter >= 24 || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? '' : addInsideCredit(item)}>
                                                                        <FpgPlusIcon className="" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                    <span className="pointer" onClick={() => removeInsideCredit(item._id, insideCredit._id)}>
                                                                        <FpgMinusIcon className="" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                    </>
                                                                }
                                                            </p>
                                                        </div>
                                                        <span style={{ color: 'red' }}>{secondFormValidator.current.message(`firstName && lastName${index}`, (insideCredit.firstName && insideCredit.lastName), 'CFirstLast|required')}</span>
                                                        </>
                                                    ))}
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="form_group">
                                <p className="form_group_title">FilmFreeway Submitter Information</p>
                            </div>
                            <div className="form_group">
                                <label>First Name*</label>
                                <div className="form_group_input">
                                    <input type="text" name="firstName" id="firstName"
                                        value={formDetail.firstName}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                    <span style={{ color: 'red' }}>{secondFormValidator.current.message('firstName', formDetail.firstName, 'firstName|required')}</span>
                                </div>
                            </div>
                            <div className="form_group">
                                <label>Middle Name</label>
                                <div className="form_group_input">
                                    <input type="text" name="middleName" id="middleName"
                                        value={formDetail.middleName}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form_group">
                                <label>Last Name*</label>
                                <div className="form_group_input">
                                    <input type="text" name="lastName" id="lastName"
                                        value={formDetail.lastName}
                                        onChange={(e) => onInputChange(e)}
                                    />
                                    <span style={{ color: 'red' }}>{secondFormValidator.current.message('lastName', formDetail.lastName, 'lastName|required')}</span>
                                </div>
                            </div>
                            <div className="form_group">
                                <label>Email*</label>
                                <div className="form_group_input">
                                    <input type="email" name="email" id="email"
                                        maxLength={255}
                                        value={formDetail.email}
                                        onChange={(e) => onEmail_ProjectUserChange(e, 'EMAIL')}
                                    />
                                    {checkTyping.emailLoader && <><img src={loader} /></>}
                                    <span style={{ color: 'red', display: 'block' }}> {checkEmail.error ? checkEmail.errorMessage : <> {secondFormValidator.current.message('email', formDetail.email, 'formEmail|email|required')} </>} </span>
                                </div>
                            </div>
                            <div className="form_group">
                                <p className="form_group_title">Login Information</p>
                            </div>
                            <div className="form_group">
                                <label>Project User ID*</label>
                                <div className="form_group_input">
                                    <input type="text" name="projectUserId" id="projectUserId"
                                        value={formDetail.projectUserId}
                                        onChange={(e) => onEmail_ProjectUserChange(e, 'PROJECT_USER_ID')}
                                    />
                                    {checkTyping.projectLoader && <><img src={loader} /></>}
                                    <span style={{ color: 'red', display: 'block' }}> {
                                    checkProjectID.error ? <div className='srv-validation-message'>{checkProjectID.errorMessage}</div> :
                                     <> {secondFormValidator.current.message('projectUserId', formDetail.projectUserId, 'pId_alpha_num')} </>} </span>
                                </div>
                            </div>
                        </div>
                }
                <div className="content_management">
                    <div className="btn_wrapper">
                        {
                            !creditShow ?
                                <button className="orangeBTN" type="button" onClick={NextStep}>NEXT</button>
                                :
                                <>
                                <button className="grayBTN" type="button" onClick={BackStep}>BACK</button>
                                <button className="orangeBTN" type="button" disabled={btnDisabel} onClick={(e) => onSubmit(e)}>SUBMIT</button>
                                </>
                        }
                    </div>
                </div>

            </form>
            {alertPopup ?
                <div className="delete_popup_wrapper create_project_alert">
                    <span className="popup_overlay"></span>
                    <div className="popup_inner">
                        <h2 className="popup_title text_center relative">
                            Acceptance Form
                                <img src={close} onClick={() => setAlertPopup(false)} />
                        </h2>
                        <div className="details">
                            <h3 className="detail_title text_center">Are you sure you want to close this form?</h3>
                            <div className="content_management">
                                <div className="field_row text_center">
                                    <button className="grayBTN"
                                        type="button"
                                        onClick={() => props.closeProject()}
                                    >YES</button>
                                    <button className="orangeBTN active"
                                        type="button"
                                        onClick={() => setAlertPopup(false)}>NO</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }
            {errorPopup.flag ?
                <div className="delete_popup_wrapper create_project_alert">
                    <span className="popup_overlay"></span>
                    <div className="popup_inner">
                        <h2 className="popup_title text_center relative">
                            Acceptance Form
                                <img src={close} onClick={() => setErrorPopup({flag:false,message:''})} />
                        </h2>
                        <div className="details">
                            <h3 className="detail_title text_center">{errorPopup.message}</h3>
                            <div className="content_management">
                                <div className="text_center">
                                    <button className="orangeBTN"
                                        type="button"
                                        onClick={() => setErrorPopup({flag:false,message:''})}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }

        </div>
        {Loading && <Loader />}
        </div>
        </>

    )
}

export default CreateProjectPopup